export const navBarConstants = {
    NAV_BAR_TOGGLE_SIDEBAR: "NAV_BAR_TOGGLE_SIDEBAR",
    NAV_BAR_CLOSE_SIDEBAR: "NAV_BAR_CLOSE_SIDEBAR",
    NAV_BAR_SHOW_BAR: "NAV_BAR_SHOW_BAR",
    NAV_BAR_HIDE_BAR: "NAV_BAR_HIDE_BAR",
};